export default class UserService {
  constructor($http, appConfig) {
    "ngInject";

    this.$http = $http;
    this.appConfig = appConfig;
  }

  loadDashoardPanelData(panel, entityId, userId, isManager, userIdOverride, selectedDate, page) {
    let url = this.appConfig.apiServiceBaseUri + `api/user/${panel}/${entityId}`

    if (isManager && userIdOverride) {
      url += `/${userIdOverride || userId}`;

      if (selectedDate) {
        url += `/${selectedDate.toUniversalFormat()}`;
      }
    }
    else {
      url += `/${isManager ? null : userId}`;
      
      if (selectedDate) {
        url += `/${selectedDate.toUniversalFormat()}`;
      }
    }

    if (page) {
      url += `/${page}`;
    }    

    return this.$http.get(url);
  }

  promisesStats(entityId, userId, isManager, userIdOverride, selectedDate) {
    return this.loadDashoardPanelData('stats/promises', entityId, userId, isManager, userIdOverride, selectedDate);
  }

  promises(entityId, userId, isManager, userIdOverride, selectedDate, page) {
    return this.loadDashoardPanelData('promises', entityId, userId, isManager, userIdOverride, selectedDate, page);
  }

  recentContacts(entityId, userId, isManager, userIdOverride) {
    return this.loadDashoardPanelData('recentcontacts', entityId, userId, isManager, userIdOverride);
  }

  openEnquiriesStats(entityId, userId, isManager, userIdOverride) {
    return this.loadDashoardPanelData('stats/openenquiries', entityId, userId, isManager, userIdOverride);
  }

  openEnquiries(entityId, userId, isManager, userIdOverride, page) {    
    return this.loadDashoardPanelData('openenquiries', entityId, userId, isManager, userIdOverride, null, page);
  }

  openFinancesStats(entityId, userId, isManager, userIdOverride) {
    return this.loadDashoardPanelData('stats/openfinances', entityId, userId, isManager, userIdOverride);
  }

  openFinances(entityId, userId, isManager, userIdOverride, page) {
    return this.loadDashoardPanelData('openfinances', entityId, userId, isManager, userIdOverride, null, page);
  }

  pendingDeliveriesStats(entityId, userId, isManager, userIdOverride, selectedDate) {
    return this.loadDashoardPanelData('stats/pendingdeliveries', entityId, userId, isManager, userIdOverride, selectedDate);
  }

  pendingDeliveries(entityId, userId, isManager, userIdOverride, selectedDate, page) {
    return this.loadDashoardPanelData('pendingdeliveries', entityId, userId, isManager, userIdOverride, selectedDate, page);
  }

  salesMatches(entityId, userId, isManager, userIdOverride) {
    return this.loadDashoardPanelData('salesmatches', entityId, userId, isManager, userIdOverride);
  }

  webEnquiriesStats(entityId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/user/stats/webenquiries/${entityId}`);
  }

  webEnquiries(entityId, page) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/user/webenquiries/${entityId}/${page}`);
  }

  expiringContactsStats(entityId, userId, isManager, userIdOverride) {
    return this.loadDashoardPanelData('stats/expiringcontacts', entityId, userId, isManager, userIdOverride);
  }

  expiringContacts(entityId, userId, isManager, userIdOverride, page) {
    return this.loadDashoardPanelData('expiringcontacts', entityId, userId, isManager, userIdOverride, null, page);
  }
  
  getLocationUsers(entityId, includeCurrent, workType) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/user/location/${entityId}/${includeCurrent ? includeCurrent : 'null'}/${workType}`);
  }

  getEntityUsers(locationIds) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/user/entityusers/${locationIds}`);
  }

  getUserStats(entityId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/user/userstats/${entityId}`);
  }  
}



// WEBPACK FOOTER //
// ./client/app/components/user/user.service.js